import {IController} from "angular";
import * as angular from "angular";

export class PlanningDepotsTableRowCtrl implements IController {
  depot: any;
  onRemove: Function;

  /* @ngInject */
  constructor() {
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningDepotsTableRow', {
    bindings: {
      depot: '<',
      onRemove: '&'
    },
    template: require('./planning-depots-table-row.html').default,
    controller: PlanningDepotsTableRowCtrl
  });
